module.exports = __webpack_public_path__ + "img/logo.80b02dc7.png";